import { Context } from '@nuxt/types';
import articleUrl from '@root/modules/article/utils/buildArticleUrl';
import matchChannel from '@root/common/utils/matchChannel';
import { Data as ArticleData } from '@root/modules/article/types/article';
import getChannelDomain from '@root/modules/channel/utils/getChannelDomain';
import ArticleService from '@root/modules/article/services/Article.service';

const errorMessage = {
  message: 'article.error.not_found',
  statusCode: 404,
};

const handleShortUrl = async (context: Context, isCommentsUrl = false) => {
  const { app, req, route } = context;

  const channelConfig = app.$channelConfig('config');

  const variables = { id: route.params.id };
  const articleService = new ArticleService({ req });
  const { article } = await articleService.fetch({ variables, channelConfig });
  const domain = article?.primaryCategory.channel.domain;
  const fakeDomainEnabled = context.$config.FAKE_DOMAIN_ENABLED;
  return `${articleUrl({ article, domain, fakeDomainEnabled })}${isCommentsUrl ? `/diskusija` : ``}`;
};

const getArticlePath = async (context: Context) => {
  const { error, store } = context;

  const isShortUrl = context.route.path.includes('/a/');
  if (isShortUrl) {
    const isCommentsUrl = context.route.path.includes('/diskusija');
    return await handleShortUrl(context, isCommentsUrl);
  }

  try {
    const { article }: { article: ArticleData } = store.getters['article/getTempData'];

    if (article) {
      const { app } = context;
      const { id, temporaryAllowedDomains } = app.$channelConfig('settings');
      const domain = getChannelDomain(id) || 'www.delfi.lt';
      const domains = temporaryAllowedDomains ? [...new Set([...temporaryAllowedDomains, domain])] : domain;

      const activeDomain = article.primaryCategory?.channel?.url;

      if (!activeDomain) {
        return false;
      }

      const sameChannel = matchChannel(domains, activeDomain);
      if (sameChannel) {
        return false;
      } else {
        // Redirect article if it does not belong to active channel
        const fakeDomainEnabled = context.$config.FAKE_DOMAIN_ENABLED;
        return articleUrl({ article, domain: domains, fakeDomainEnabled });
      }
    } else {
      error(errorMessage);
    }
  } catch (e) {
    error(errorMessage);
  }
  return false;
};

export default getArticlePath;
